// extracted by mini-css-extract-plugin
export var avatarContainer = "_a7-0";
export var avatarTypingWave = "_a7-i";
export var gray = "_a7-f";
export var green = "_a7-c";
export var icon = "_a7-9";
export var image = "_a7-1";
export var lg = "_a7-6";
export var md = "_a7-5";
export var presenceDot = "_a7-b";
export var red = "_a7-d";
export var sm = "_a7-4";
export var status = "_a7-a";
export var typingDot = "_a7-h";
export var typingPill = "_a7-g";
export var xl = "_a7-7";
export var xs = "_a7-3";
export var xxl = "_a7-8";
export var xxs = "_a7-2";
export var yellow = "_a7-e";